<p-dialog
	#dialogRef [(visible)]="showDialog" [modal]="true" [style]="{width: '50vw', minWidth: '350px'}"
	[draggable]="false" [resizable]="false" [maximizable]="true" [breakpoints]="{'768px': '100vw'}"
	(onHide)="closeDialog()"
	header="{{ dialogMode === 'edit' ? ('modals.deductionPayment.editTitle' | translate) : ('modals.deductionPayment.addTitle' | translate) }}">

	<form>
		<div>
			<p-table [value]="localLines?.controls" styleClass="p-datatable-sm" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th>{{ 'form.field.amount' | translate }}</th>
						<th style="width: 52px;"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-row let-i="rowIndex">
					<tr [formGroup]="row">
						<td>
							<span class="p-column-title">{{ 'form.field.amount' | translate }}</span>
							<p-inputNumber formControlName="amount" locale="en-US" [minFractionDigits]="2"
								[maxFractionDigits]="2" [min]="0.01"
								[ngClass]="{'ng-invalid ng-dirty': (submitted || row.get('amount')?.touched) && row.get('amount')?.invalid}"
								placeholder="0.00" (onInput)="onAmountInput($event, i)"></p-inputNumber>
							<div *ngIf="(submitted || row.get('amount')?.touched) && row.get('amount')?.errors?.['required']"
								class="invalid-feedback text-danger d-block">
								{{ 'form.validation.required' | translate : {field: ('form.field.amount' | translate)} }}
							</div>
							<div *ngIf="(submitted || row.get('amount')?.touched) && row.get('amount')?.errors?.['min']"
								class="invalid-feedback text-danger d-block">
								{{ 'form.validation.min' | translate: { field: ('form.field.amount' | translate), min: 0.01 } }}
							</div>
						</td>
						<td class="text-center">
							<span class="p-column-title"></span>
							<!-- Only one line allowed, so disable remove button -->
							<button type="button" pButton icon="pi pi-trash"
								class="p-button-rounded p-button-danger p-button-text"
								style="width: 2rem; height: 2rem; min-width: unset;" (click)="removeLine(i)"
								disabled
								[title]="'modals.common.delete' | translate"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="footer">
					<tr>
						<td colspan="2" class="text-end fw-bold fs-5 pe-3">
							<span class="fw-bold text-end">
								{{ 'modals.common.total' | translate }}
							</span>
							<span>{{ displayTotalAmount | number:'1.2-2' }}</span>
						</td>
					</tr>
				</ng-template>
			</p-table>
			<!-- Mobile view: show total below input, matching cash modal's mobile layout -->
			<div class="d-md-none mt-3">
				<div class="d-flex justify-content-between align-items-center">
					<span class="fw-bold text-end">
						{{ 'modals.common.total' | translate }}
					</span>
					<span>
						{{ displayTotalAmount | number:'1.2-2' }}
					</span>
				</div>
			</div>
		</div>
		<div *ngIf="debug" class="alert alert-info mt-2">
			<strong>DEBUG:</strong>
			Lines: {{ localLines.value | json }}
		</div>
	</form>
	<ng-template pTemplate="footer">
		<button type="button" pButton [label]="'modals.common.cancel' | translate" icon="pi pi-times"
			class="p-button-danger" (click)="closeDialog()" [title]="'modals.common.cancel' | translate"></button>
		<button pButton type="button" class="p-button-success" [label]="'modals.common.updateLines' | translate"
			icon="pi pi-check" (click)="onSave()" [disabled]="localLinesInvalid && submitted">
		</button>
	</ng-template>
</p-dialog>
